/* eslint-disable react/jsx-no-target-blank */
import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Paper from '@material-ui/core/Paper';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Typography from '@material-ui/core/Typography';
import { Link } from '@material-ui/core';

const WEBSITE_ENTRIES = [
  'bloodsugar - blog/1',
  'bloodsugar - blog/c',
  'bloodsugar - blog/2',
  'bloodsugar - interstitial/1',
  'bloodsugar - interstitial/c',
  'collagenpeptides - blog/6',
  'collagenpeptides - blog/1',
  'collagenpeptides - blog/8',
  'collagenpeptides - blog/c',
  'collagenpeptides - blog/13',
  'collagenpeptides - blog/14',
  'collagenpeptides - interstitial/c',
  'curcumin - blog/archive',
  'curcumin - blog/42',
  'curcumin - blog/43',
  'curcumin - blog/41',
  'curcumin - blog/c',
  'curcumin - blog/3',
  'curcumin - blog/40',
  'curcumin - interstitial/1',
  'curcumin - interstitial/c',
  'curcumin - interstitial/4',
  'curcumin - interstitial/3',
  'curcumin - interstitial/2',
  'hydrate - blog/c',
  'hydrate - interstitial/1',
  'hydrate - interstitial/c',
  'hydrate - interstitial/2',
  'jointsupport - blog/6',
  'jointsupport - blog/1',
  'jointsupport - blog/8',
  'jointsupport - blog/c',
  'jointsupport - blog/4',
  'jointsupport - blog/3',
  'jointsupport - blog/2',
  'jointsupport - blog/5',
  'lipolean - interstitial/c',
  'liversupport - blog/c',
  'multicollagen - blog/c',
  'multivitamin - blog/archive',
  'multivitamin - blog/c',
  'multivitamin - interstitial/1',
  'multivitamin - interstitial/c',
  'preprobiotic - blog/1',
  'preprobiotic - blog/c',
  'vitamind3 - blog/c',
];

const formatEntryUrl = (entry) => {
  const [subdomain, path] = entry.split(' - ');
  const sanitizedPath = path.startsWith('/') ? path.slice(1) : path;
  return `https://${subdomain}.manna.com/${sanitizedPath}`;
};

const useStyles = makeStyles((theme) => ({
  container: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(3),
  },
  listItem: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    '&:last-child': {
      borderBottom: 'none',
    },
  },
}));

export default function WebsitesPage({ onRender }) {
  const classes = useStyles();

  useEffect(() => {
    if (onRender) {
      onRender('Websites');
    }
  }, [onRender]);

  return (
    <Container className={classes.container} maxWidth='sm'>
      <Paper className={classes.paper} elevation={2}>
        <Typography variant='h6' gutterBottom>
          Websites
        </Typography>
        <List disablePadding>
          {WEBSITE_ENTRIES.map((entry) => {
            const url = formatEntryUrl(entry);
            return (
              <ListItem
                key={entry}
                className={classes.listItem}
                component='a'
                href={url}
                target='_blank'
                rel='noopener noreferrer'
                button
              >
                <Link>
                  <ListItemText primary={url.replace(/^https?:\/\//, '')} />
                </Link>
              </ListItem>
            );
          })}
        </List>
      </Paper>
    </Container>
  );
}
